/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: detectGeo->detectGeo_Whois)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

/**
 * Alle Methoden im Zusammenhang mit den Whois-Informationen
 */
export class searchIpWhois {
    /**
     * Initialisiere die Clipboard-Unterstützung
     */
    public static initClipboard() {
        let ClipboardJS = require("clipboard");
        let clipboard = new ClipboardJS('.btnClipboard');
        clipboard.on('success', function(e:any) {
            bootbox.alert({
                title: `${DETECTPHRASE["Zwischenablage"]}:`,
                message: `<p>${DETECTPHRASE["Ihre IP-Adresse"]} <i>${e.text}</i> ${DETECTPHRASE["wurde erfolgreich in die Zwischenablage kopiert"]}.</p>`,
                backdrop: true
            });
        });
        clipboard.on('error', function(e:any) {
            console.error('Clipboard-Action:', e.action);
            console.error('Clipboard-Trigger:', e.trigger);
            bootbox.alert({
                title: `${DETECTPHRASE["Zwischenablage"]}:` ,
                message: `<p>${DETECTPHRASE["Fehler beim Zugriff auf die Zwischenablage"]}.</p>`,
                backdrop: true
            });
        });
    }

    /**
     * Initialisiere IPv4-Whois
     *
     * @param domid string
     */
    public static initWhoisIP(domid:string) {
        $(domid).on("click", function(event) {
            event.preventDefault();

            // noinspection JSNonASCIINames
            let ipwhoisDialog = bootbox.alert({
                title: `${DETECTPHRASE["Whois-Information für"]} <i>${$("#ipadress").val()}</i>:` ,
                message: `<p><i class="fas fa-spin fa-spinner"></i> ${DETECTPHRASE["Frage die Whois-Datenbank ab"]} ... ${DETECTPHRASE["bitte warten"]}</p>`,
                backdrop: true
            });
            
            if ($("#publicIp").hasClass("label-success")) {
                // ÖFfentliche IP Adresse -> führe Whois aus
                ipwhoisDialog.init(function(){
                    let whois:JQuery.jqXHR;
                    whois = $.getJSON(
                        "https://ipv4-test.dein-ip-check.de/ajax/v2/whois?" + $.param({ 'header':false, 'lang':DETECTLANGUAGE, 'ip':$("#ipadress").val()}),
                        function() { })
                        .done(function() {
                            ipwhoisDialog.find(".bootbox-body").html( whois.responseJSON.whois );
                        })
                        .fail(function() {
                            ipwhoisDialog.find(".bootbox-body").html( DETECTPHRASE["Whois-Abfrage konnte nicht gestartet werden"] );
                        })
                });
            } else {
                // Private IP Adresse -> informiere Nutzer über nicht verfügbarem Whois
                ipwhoisDialog.init(function() {
                    // noinspection JSNonASCIINames
                    ipwhoisDialog.find(".bootbox-body").html(DETECTPHRASE["Whois-Abfrage für eine private IP-Adresse ist nicht möglich"]);
                });
            }
            
        });
    }
}
